import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { ButtonSize, ButtonTheme, ButtonV2 } from 'builder/components/Button'
import { Shadows } from 'builder/styles/shadows'

export const SkipButtonContainer = styled.div`
  position: fixed;
  top: 32px;
  right: 32px;
  z-index: 10100;
`

export const SkipButton = styled(ButtonV2).attrs({
  size: ButtonSize.small,
  theme: ButtonTheme.ghost,
})`
  ${Shadows.lightWithBorder.low};
  border-radius: 24px;
  padding: 8px 24px 8px 32px;
  background-color: ${Colors.White};
  border: none;
  gap: 2px;

  &:hover {
    ${Shadows.lightWithBorder.mid};
    background-color: ${Colors.White};
  }
`
